import { useEffect, useState } from 'react'
import ConfirmDialog from './ConfirmDialog.jsx'
import { REPORT_REASONS } from '../lib/reportReasons.js'

/**
 * *Report* asks why before anything is sent (Q28). It used to file `abuse`
 * on one press, whatever the problem was, and a stray tap filed it.
 *
 * Nothing is preselected and *Send report* waits for a choice: a default
 * reason would put the old one-press report back behind a second press. The
 * outcome is the page's to show — the dialog closes when the request settles,
 * and "Reported." or the refusal lands where it always has, on the card.
 */
export default function ReportDialog({ open, busy = false, onSend, onClose }) {
  const [reason, setReason] = useState(null)

  // Cleared on close, not on open: reset on open, a reopened dialog painted
  // the last reason checked for a frame and then unchecked it — a click in
  // that frame (the full browser suite's retry) left *Send report* disabled.
  useEffect(() => {
    if (!open) setReason(null)
  }, [open])

  return (
    <ConfirmDialog
      open={open}
      title="Report this review"
      confirmLabel="Send report"
      confirmDisabled={!reason}
      busy={busy}
      onConfirm={() => onSend(reason)}
      onClose={onClose}
    >
      <fieldset className="choice-set">
        <legend className="field-label">What is wrong with it?</legend>
        {REPORT_REASONS.map(({ value, label }) => (
          <label className={`choice ${reason === value ? 'on' : ''}`} key={value}>
            <input
              type="radio"
              name="report-reason"
              value={value}
              checked={reason === value}
              onChange={() => setReason(value)}
            />
            <span className="row-main">
              <span className="row-title">{label}</span>
            </span>
          </label>
        ))}
      </fieldset>
    </ConfirmDialog>
  )
}
